import {WelcomeButtonVO} from '../../common/shared/api/gateway/welcome/WelcomeButtonInfoVo.interface';
import {WelcomeButtonInfo} from '../generated/types';

export function createWelcomeButtonInfo({
  title,
  scheme,
  kage_id,
}: WelcomeButtonVO): WelcomeButtonInfo {
  return {
    title,
    scheme,
    kageId: kage_id,
  };
}
